import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=25266744&scoped=true&"
import script from "./FileDropZone.vue?vue&type=script&lang=js&"
export * from "./FileDropZone.vue?vue&type=script&lang=js&"
import style0 from "./FileDropZone.vue?vue&type=style&index=0&id=25266744&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25266744",
  null
  
)

export default component.exports